<script>
  import { SkeletonText } from "carbon-components-svelte";
  import { Button } from "paxray-components-svelte";

  //// imports
  import AccordionPagination from "lib/components/accordionPagination.svelte";
  import Toggle from "lib/components/Toggle.svelte";
  // @Adrian hab das jetzt einfach mit nem Delay gelöst - vielleicht findest du ne pfiffigere Alternative?
  import { onMount } from "svelte";
  import { DOWNLOAD_ICON } from "@utils/icons.js";

  // onMount(() => {
  //   setTimeout(() => {
  //     if (filteredApps.length > 0) {
  //       selectApp(filteredApps[0]);
  //     }
  //   }, 1000);
  // });

  export let appData = [];
  export let currentApp = "";
  export let selectedLevel = 0;
  export let windowSelectionEnabled = true;
  export let kpi = "time";
  export let loading = false;
  export let exportfunction = "";
  export let enableDeselection = true;

  let firstLoad = true;

  // $: {
  //   if (selectedLevel) partitionlabel = currentApp;
  // }

  function sortByAppShare(appData) {
    return appData.sort((a, b) => b[kpi] - a[kpi]);
  }

  let sortedAppData = [];

  $: {
    updateAppData(appData);
  }

  function updateAppData(appData) {
    sortedAppData = sortByAppShare(mapAppData(appData));
  }
  // normalize ahhSpahre-Values depending on highest value

  function mapAppData(appData) {
    let highestShare = appData.length > 0 ? sortByAppShare(appData)[0][kpi] : 1;
    let displayedAppsSum = appData.reduce((total, app) => total + app[kpi], 0);
    appData.forEach((app) => {
      app.normalizedShare = (app[kpi] / highestShare) * 100;
      app.share = (app[kpi] / displayedAppsSum) * 100;
    });
    return appData;
  }

  // change displayed apps

  let displayCount = 5; // default value for number of apps shown
  let currentPage = 1;
  let displayedApps = [];

  let searchTerm = "";

  function selectApp(app) {
    if (enableDeselection) {
      currentApp === app.id ? (currentApp = "") : (currentApp = app.id);
    } else currentApp = app.id;
  }

  let filteredApps = [];

  function updateDisplay(currentPage, search, sortedAppData) {
    if (search) {
      filteredApps = sortedAppData.filter(
        (app) =>
          app.clearname.toLowerCase().includes(search.toLowerCase()) ||
          (app.windowtitle &&
            app.windowtitle.toLowerCase().includes(search.toLowerCase())),
      );
    } else {
      filteredApps = sortedAppData;
    }
    while (filteredApps.length < (currentPage - 1) * displayCount) {
      currentPage--;
    }
    displayedApps = filteredApps.slice(
      (currentPage - 1) * displayCount,
      currentPage * displayCount,
    );
  }

  $: updateDisplay(currentPage, searchTerm, sortedAppData);

  // calculate the color of the divs

  function calculateBackgroundColor(index) {
    const steps = sortedAppData.length;
    const startColor = [47, 72, 88];
    const endColor = [118, 187, 234];

    const colorStep = [
      (endColor[0] - startColor[0]) / (steps - 1),
      (endColor[1] - startColor[1]) / (steps - 1),
      (endColor[2] - startColor[2]) / (steps - 1),
    ];

    const colorValue = [
      Math.round(startColor[0] + colorStep[0] * index),
      Math.round(startColor[1] + colorStep[1] * index),
      Math.round(startColor[2] + colorStep[2] * index),
    ];

    return `rgb(${colorValue.join(",")})`;
  }

  onMount(() => {
    setTimeout(() => {
      if (
        firstLoad &&
        !currentApp &&
        appData.length > 0 &&
        !enableDeselection
      ) {
        currentApp = appData[0].id;
        firstLoad = false;
      }
    }, 500);
  });
</script>

<div
  class="app_selection_wrapper {loading ? '' : ''}"
  style={loading ? "gap: 0.5rem;" : ""}
>
  {#if windowSelectionEnabled}
    <Toggle bind:active={selectedLevel} text={"Window Titles"}></Toggle>
  {/if}
  <div class="search_wrapper">
    <div class="search">
      <div class="searchicon">
        <svg
          height="100%"
          viewBox="0 0 26 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
            fill="#1C1C20"
          />
        </svg>
      </div>
      <input
        type="text"
        bind:value={searchTerm}
        placeholder="Search for Application"
      />
    </div>
    {#if exportfunction}
      <Button icon={DOWNLOAD_ICON} kind="secondary" on:click={exportfunction} />
    {/if}
  </div>
  {#if loading}
    {#each Array(5) as _, index}
      <div
        class="appinfo_wrapper loading_wrapper {index === 0
          ? 'first-element'
          : ''}"
      >
        <SkeletonText />
      </div>
    {/each}
    <div class="last-element"></div>
  {:else}
    <div class="bar_wrapper">
      {#each displayedApps as app}
        <!-- svelte-ignore missing-declaration -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="appinfo_wrapper {app.disable ? 'disable' : ''}"
          style="border-color: {app.id == currentApp ? '#1c1c20' : '#f2f2f2'};"
          title={app.clearname +
            (app.windowtitle ? " - " + app.windowtitle : "")}
          on:click={() => {
            if (!app.disable) {
              selectApp(app);
            }
          }}
        >
          <div class="appname">
            {app.clearname + (app.windowtitle ? " - " + app.windowtitle : "")}
          </div>
          <div class="appshare bold">
            {#if Math.round(app["share"]) > 0}
              {Math.round(app["share"])}%
            {:else}
              &lt 1%
            {/if}
          </div>
        </div>
      {/each}
    </div>
  {/if}

  <AccordionPagination
    item="Apps"
    total={filteredApps.length}
    bind:currentpage={currentPage}
    itemsPerPage={displayCount}
  />
</div>

<style>
  .appinfo_wrapper {
    display: flex;
    height: 3rem;
    width: 100%;
    cursor: pointer;
    align-items: center;
    background-color: var(--pax-smoke);
    border-radius: 0.5rem;
    border: 1px solid;
    justify-content: space-between;
    padding: 0 1rem;
  }

  .appshare {
    width: fit-content;
  }

  .appname {
    white-space: nowrap;
    overflow: hidden;
    width: calc(20vw - 7rem);
    z-index: 3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
    align-items: center;
  }

  .bar_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #d9d9d9;
  }

  .app_selection_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .search_wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .search {
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
    flex-grow: 1;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .searchicon {
    height: 1.5rem;
  }

  .loading_wrapper {
    padding-right: 1rem;
    padding-top: 0.5rem;
    justify-content: center !important;
    border-color: #f2f2f2;
  }

  .first-element {
    margin-top: 0.75rem;
  }

  .last-element {
    padding-top: 0.5rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px solid #d9d9d9;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
  }

  .disable {
    color: var(--pax-black-inactive);
    cursor: default;
  }

  input:focus,
  input:active {
    outline: none;
  }
</style>
